'use client'

import React from 'react'

import { Box, chakra } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { getToggleTokens } from './Toggle.styles'

export type ToggleProps = {
  isOn: boolean
  onChange: (isOn: boolean) => void
  disabled?: boolean
  colorScheme?: ColorScheme
  'aria-label'?: string
  'data-testid'?: string
}

export const Toggle = ({
  isOn,
  onChange,
  disabled = false,
  colorScheme = 'dark',
  'aria-label': ariaLabel,
  'data-testid': testId,
}: ToggleProps) => {
  const t = getToggleTokens(colorScheme)

  return (
    <chakra.button
      aria-checked={isOn}
      aria-disabled={disabled || undefined}
      aria-label={ariaLabel}
      bg={isOn ? t.trackOn : t.trackOff}
      border='none'
      borderRadius='17px'
      cursor={disabled ? 'not-allowed' : 'pointer'}
      data-testid={testId}
      disabled={disabled}
      display='flex'
      flexShrink={0}
      height='20px'
      minWidth='34px'
      onClick={() => {
        if (!disabled) onChange(!isOn)
      }}
      opacity={disabled ? 0.5 : 1}
      padding='2px'
      role='switch'
      transition='background 0.2s ease'
      type='button'
      width='34px'
    >
      <Box
        bg={t.knob}
        borderRadius='50%'
        height='16px'
        transform={isOn ? 'translateX(14px)' : 'translateX(0)'}
        transition='transform 0.2s ease'
        width='16px'
      />
    </chakra.button>
  )
}
